module.exports = __webpack_public_path__ + "img/sphere12-graph.b148148f.png";